import styled, { CSSProperties } from "styled-components";

import { IButton } from "@interfaces";

export const SharedButton = styled.button<IButton>`
    background-color: ${(p) => p.bg_color};
    border-radius: 30px;
    color: #fff;
    cursor: pointer;
    height: 56px;
    /* font-size: 20px; */
    border: none;

    ${(p) => {
        if (p.size === "large") return "width:100%;";
    }}
    ${(p) => {
        if (p.width) return `width:${p.width};`;
    }}
    ${(p) => {
        if (p.size === "small") return "min-width: 156px;";
    }}
    ${(p) => {
        if (p.color) return `color:${p.color};`;
    }}
   
    &:disabled {
        opacity: 0.75;
    }
`;

export const StyleSocialButton = styled.div<{ color?: string }>`
    cursor: pointer;
    background-color: ${(props) => props?.color || "#fff"};
    padding: 10px 0;
    width: 100%;
    box-sizing: border-box;
    border-radius: 36px;
    display: flex;
    transition: all 0.5;
    height: 56px;

    .social-icon {
        width: 36px;
        margin: auto;
    }
`;

interface IPropPreview {
    color: string;
    text: string;
}
interface IPropsSub {
    size?: "default" | "small" | "large" | "92" | "164" | undefined;
    type: "default" | "sub" | "textMain" | "disable" | "Gray" | "backgroundGray" | "red";
    text: JSX.Element | JSX.Element[] | string | null;
    className?: string;
    style?: CSSProperties;
    htmlType?: "button" | "reset" | "submit" | undefined;
    onClick?: () => void;
    disable?: boolean;
}
export const SharedButtonPreview = (props: IPropPreview) => {
    const { color, text } = props;
    return <StyledButtonPreview color={color}>{text}</StyledButtonPreview>;
};
export const SharedButtonSub = (props: IPropsSub) => {
    const { text, size, type, className, style, htmlType, onClick, disable } = props;
    return (
        <StyleButtonSub
            disabled={disable || type === "disable"}
            size={size}
            type={htmlType}
            typeBtn={type}
            className={className}
            style={style}
            onClick={onClick}
        >
            {text}
        </StyleButtonSub>
    );
};
export const StyledCancelButton = styled((props) => <SharedButtonSub {...props} />)`
    font-size: 16px;
    min-width: 112px;
    font-weight: 500;
`;

export const StyleButtonSub = styled.button<{
    size: "default" | "small" | "large" | "92" | "164" | undefined;
    typeBtn: "default" | "sub" | "textMain" | "disable" | "Gray" | "backgroundGray" | "red";
}>`
    padding: 16px 32px;
    font-weight: 500;
    border-radius: 4px;
    cursor: pointer;
    // font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 8px;
    @media (max-width: ${(p) => p.theme.breakPoints.breakOnlyMobile}) {
        padding: 12px 24px;
        ${(p) => {
        if (p.size !== "large") {
            return `
            max-width:140px;
            `;
        }
    }}
    }
    ${(p) => {
        if (p.typeBtn === "sub") {
            return `
             color: #283441;
             background-color:transparent;
             border: 0.5px solid rgba(112,112,112,0.5);
            `;
        }
        if (p.typeBtn === "disable") {
            return `
            color: #646464;
            background: #F7F7F8;
            border: 0.5px solid #A5A5A5;
            `;
        }
        if (p.typeBtn === "Gray") {
            return `
             color: #646464;
             background-color:#E1E1E1;
             border: none;
            `;
        }
        if (p.typeBtn === "backgroundGray") {
            return `
             color: #fff;
             background-color:#646464;
             border: none;
            `;
        }
        if (p.typeBtn === "red") {
            return `
             color: #fff;
             background-color:#F22F46;;
             border: none;
            `;
        }
    }}
    ${(p) => {
        if (p.size === "large") {
            return `
            width: 100% !important;
            max-width:initial;
            margin-top:12px;
            `;
        }
        if (p.size === "small") {
            return `
            padding:4px 12px;
            line-height:unset;
            font-size: 12px;
            max-width:initial;
            `;
        }
        if (p.size === "92") {
            return `
            width:92px;
            font-size: 16px;
            height:39px;
            `;
        }
        if (p.size === "164") {
            return `
            width:164px;
            font-size: 20px;
            height:52px;
            `;
        }
        if (p.size === "default") {
            return `
            padding:6px 18px;
            line-height:unset;
            font-size: 16px;
            max-width:initial;
            `;
        }
    }}
`;

export const StyledSubmitButton = styled((props) => <SharedButtonSub {...props} />)`
    font-size: 16px;
    margin-right: 12px;
    min-width: 112px;
    font-weight: 500;
`;
const StyledButtonPreview = styled.div<{ color: string }>`
    background-color: ${(p) => p.color};
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    padding: 12px 0;
    color: #ffffff;
    width: 100%;
    text-align: center;
    border-radius: 8px;
    cursor: pointer;
`;
